/* @flow */

import useFeatureDecisions from 'src/shared/app/feature/hook/useFeatureDecisions';
import useVirtualBraindate from 'plugin/virtual-braindate/hook/useVirtualBraindate';

export default function useRouteConfig(): Object {
  const {
    areEmailNotificationsEnabled,
    isSignupEnabled,
    isOnboardingSkipped,
  } = useFeatureDecisions();
  const isVirtualBraindateEnabled = useVirtualBraindate();

  return {
    areEmailNotificationsEnabled,
    isSignupEnabled,
    isOnboardingSkipped,
    isVirtualBraindateEnabled,
  };
}
